import CustomSelect, {
  ICustomSelectOption,
} from "src/components/Select/CustomSelect";

export interface ICustomSelectCellEditor {
  options: ICustomSelectOption[];
  value?: string | any[];
  onChange: (e: any) => void;
  placeholder?: string;
}
const CustomSelectCellEditor: React.FC<ICustomSelectCellEditor> = ({
  options,
  value,
  onChange,
  placeholder,
}) => {
  return (
    <CustomSelect
      placeholder={placeholder}
      creatable
      options={options}
      value={value}
      onChange={onChange}
    />
  );
};

export default CustomSelectCellEditor;
